// extracted by mini-css-extract-plugin
module.exports = {"location_tiles":"ShipmentsTrackPageFeature_location_tiles__2ZX_4","itemContainer":"ShipmentsTrackPageFeature_itemContainer__3xjq4","item":"ShipmentsTrackPageFeature_item__Llj61"};